import BasePage from "../modules/basePage";
import skinVisualizer from "../modules/skinVisualizer/skinVisualizer";
import Alpine from "alpinejs";

// Styles
import "../../css/pages/SkinVisualizerPage.scss";

class SkinVisualizerPage extends BasePage {
    constructor(...opts) {
        Alpine.data("skinVisualizer", skinVisualizer);
        super(...opts);
    }

    init() {
        super.init();
    }

    onReady() {
        super.onReady();
    }
}

new SkinVisualizerPage();
